module.exports = __webpack_public_path__ + "static/bnr_square@3x-de139920ee9db2e62a5c63ec760a27b9.webp";